export default __webpack_public_path__ + "static/media/brandHero.47387dc9.jpg";